import React, { forwardRef } from "react";

import styled from "styled-components/macro";

const StaxCardNumberInput = forwardRef((props, ref) => {
  return (
    <div
      ref={ref}
      data-cy="stax-card-number-input-container"
      id="card-number"
      className="card-number"
      style={{ height: "32px" }}
    />
  );
});

export default StaxCardNumberInput;
